import { pxToRem } from '../../helpers'
import { buttonReset } from '../Button'
import { StyleFn } from '..'

const transitionDuration = '250ms'
const transitionFunction = 'cubic-bezier(0.33, 1, 0.68, 1)'

export const ProgressIndicator: StyleFn = ({ color, size }) => ({
  root: {
    display: 'flex',
    transition: `transform ${transitionDuration} ${transitionFunction}`,
  },
  _vertical: {
    flexDirection: 'column',
  },
  container: {
    display: 'flex',
    alignItems: 'baseline',
    maxWidth: pxToRem(140),
    maxHeight: pxToRem(140),
    overflow: 'hidden',
  },
  step: {
    ...buttonReset,
    borderRadius: '50%',
    height: size.spacing[8],
    width: size.spacing[8],
    backgroundColor: color.palette.warmgrey[60],
    margin: size.spacing[6],
    cursor: 'pointer',
    transition: `all ${transitionDuration} ${transitionFunction}`,
    transitionProperty: 'width, height, margin',
    '&:after': {
      padding: size.spacing[4],
      content: "''",
      borderRadius: '50%',
    },
  },
  step_beforeend: {
    height: size.spacing[6],
    width: size.spacing[6],
    margin: `calc(0.375rem + 1px)`,
  },
  step_end: {
    height: size.spacing[4],
    width: size.spacing[4],
    margin: `calc(0.375rem + 2px)`,
  },
  step_selected: {
    backgroundColor: color.palette.primaryblue[60],
  },
})
